import { Component, OnInit } from '@angular/core';
import { KlixService } from 'src/app/services/klix.service';
declare var require: any;
var moment = require('moment');

@Component({
    selector: 'app-publiposte',
    templateUrl: './publiposte.component.html',
    styleUrls: ['./publiposte.component.scss']
})
export class PubliposteComponent implements OnInit {
    devis = {
        prixunitaire: 450,
        quantite: 1,
        client: 'CARPROMO',
        adr1: 'Immeuble Le Cardinet',
        adr2: '8 rue Bernard Buffet',
        adr3: '75017 PARIS',
        numdevis: '35',
        devis: 'a calculer',
        datedevis: moment().lang("fr").format('LL'),
        prixHT: '',
        tva: '',
        ttc: '',
        ht30: '',
        tva30: '',
        ttc30: '',

    };
    locataireSel = {
        nom: "Mohamed DAKKAK", info: {
            proprietaire: 'SCI SATURNE',
            hc: '800',
            charge: '50',
            ttc: '850',
            locataire: 'Mohamed DAKKAK',
            du: '01/01/2019',
            au: '31/01/2019',
            faitle: '05/02/2019',
            adresse: '12 rue Carnot, 92300 Levallois-Perret'
        }
    };
    locataires = [
        {
            nom: "Mohamed DAKKAK", info: {
                proprietaire: 'SCI SATURNE',
                hc: '800',
                charge: '50',
                ttc: '850',
                locataire: 'Mohamed DAKKAK',
                du: '01/01/2019',
                au: '31/01/2019',
                faitle: '05/02/2019',
                adresse: '12 rue Carnot, 92300 Levallois-Perret'
            }
        }, {
            nom: "Jean-Alfred MANE", info: {
                proprietaire: 'Raissa ATCHY',
                hc: '640',
                charge: '40',
                ttc: '680',
                locataire: 'Jean-Alfred MANE',
                du: '01/01/2019',
                au: '31/01/2019',
                faitle: '05/02/2019',
                adresse: `21 rue Estienne d'Orves, 92110 Clichy`
            }
        }];

    constructor(private klixService: KlixService) {
    }

    ngOnInit() {

    }

    onChange(newValue) {
        console.log(newValue);
        this.locataireSel = newValue;
        // ... do other stuff here ...
    }

    calcule() {
        let dsa = this.devis;
        dsa.devis = moment().format('YYYYMMDD') + ('00' + dsa.numdevis).substring(('00' + dsa.numdevis).length - 3);
        let ht = (Math.round((dsa.prixunitaire * dsa.quantite) * 100) / 100);
        dsa.prixHT = ht.toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        dsa.tva = (Math.round((ht * 0.2) * 100) / 100).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        dsa.ttc = (Math.round((ht * 1.2) * 100) / 100).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        dsa.ht30 = (Math.round((ht * .3) * 100) / 100).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        dsa.tva30 = (Math.round((ht * .2 * .3) * 100) / 100).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        dsa.ttc30 = (Math.round((ht * 1.2 * .3) * 100) / 100).toLocaleString('fr', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    }

    getpdf(type) {
        let balises = []
        if (type == 'quittance') {
            balises.push({ balise: 'proprietaire', valeur: this.locataireSel.info.proprietaire });
            balises.push({ balise: 'hc', valeur: this.locataireSel.info.hc });
            balises.push({ balise: 'charge', valeur: this.locataireSel.info.charge });
            balises.push({ balise: 'ttc', valeur: this.locataireSel.info.ttc });
            balises.push({ balise: 'locataire', valeur: this.locataireSel.info.locataire });
            balises.push({ balise: 'du', valeur: this.locataireSel.info.du });
            balises.push({ balise: 'au', valeur: this.locataireSel.info.au });
            balises.push({ balise: 'adresse', valeur: this.locataireSel.info.adresse });
            balises.push({ balise: 'faitle', valeur: this.locataireSel.info.faitle });
            this.klixService.publiposte('quittance.doc', balises).then(e => {
                // console.log(e);
                let base64file = e.data.fichierBase64;
                this.showPdf(base64file, `quittance_${this.replaceAll(this.locataireSel.info.du, '/', '_')}.pdf`);
            })
        } else {
            let dsa = this.devis;
            balises.push({ balise: 'prixunitaire', valeur: dsa.prixunitaire });
            balises.push({ balise: 'quantite', valeur: dsa.quantite });
            balises.push({ balise: 'client', valeur: dsa.client });
            balises.push({ balise: 'adr1', valeur: dsa.adr1 });
            balises.push({ balise: 'adr2', valeur: dsa.adr2 });
            balises.push({ balise: 'adr3', valeur: dsa.adr3 });
            balises.push({ balise: 'numdevis', valeur: dsa.numdevis });
            balises.push({ balise: 'devis', valeur: dsa.devis });
            balises.push({ balise: 'datedevis', valeur: dsa.datedevis });
            balises.push({ balise: 'prixHT', valeur: dsa.prixHT });
            balises.push({ balise: 'tva', valeur: dsa.tva });
            balises.push({ balise: 'ttc', valeur: dsa.ttc });
            balises.push({ balise: 'typedocument', valeur: 'doc' });
            balises.push({ balise: 'ht30', valeur: dsa.ht30 });
            balises.push({ balise: 'tva30', valeur: dsa.tva30 });
            balises.push({ balise: 'ttc30', valeur: dsa.ttc30 });

            let fic = (type == 'devissansacompte') ? 'devissansacompte.doc' : 'devisavecacompte.doc'
            this.klixService.publiposte(fic, balises).then(e => {
                // console.log(e);
                let base64file = e.data.fichierBase64;
                this.showPdf(base64file, `D_${dsa.devis}.doc`);
            })
        }

        // balises.push({ balise: 'traitements', valeur: this.analyse['sous_type_analyse'] + (this.analyse['ts1'] != '' ? ' +' + this.analyse['ts1'] : '') + (this.analyse['ts2'] != '' ? ' +' + this.analyse['ts2'] : '') });
        // balises.push({ balise: 'atas', valeur: (this.analyse['atas1'] != '' ? this.analyse['atas1'] : '') + (this.analyse['atas2'] != '' ? ' +' + this.analyse['atas2'] : '') });
        // balises.push({ balise: 'image1', valeur: this.graph.getImage() });


    }

    replaceAll(string, stringToChange, changeWith) {
        return string.replace(new RegExp(`[${stringToChange}]`, 'g'), changeWith)
    }

    recalcDevis() {
        // moment(data.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    showPdf(base64file, nomfichier) {
        const linkSource = 'data:application/pdf;base64,' + base64file + '\n';
        const downloadLink = document.createElement("a");
        const fileName = nomfichier;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

}
